import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef, HostBinding } from '@angular/core';
import { slideToRight } from '../../../shared/animations.collections';
import { EventListenerService } from '../../../services/close-listenenr.service';
import { NavMenu } from '../nav-menu';
import { CommonService } from '../../../services/common.service';
import { MyAccountService} from '../../../services/myAccount.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { FeedbackInfo} from '../../../models/feedback-info.model';
import { NgProgress } from 'ngx-progressbar';
import { ApiResponse } from '../../../models/api-response.model';
import { Subscription } from 'rxjs';
import { NgProgressService } from '../../../services/ngProgress.service';

@Component({
    selector: 'app-help',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.css'],
    animations: [slideToRight()]
})
export class HelpComponent extends NavMenu implements OnInit {

    @HostBinding('@slideToRight') ani;

    title = "HELP";
    sendComments:FeedbackInfo = <FeedbackInfo>{};
    helpForm: FormGroup;
    disableButton: boolean;
    errorMsg: string;
    showResult: boolean;
    imageFile: any;
    formData = new FormData();
    fileList: FileList;
    hasEmptyQuestions:boolean = true;
    response:ApiResponse;
    passQuestionSubscription$: Subscription;
    completeSubmission:boolean = false;
    fileListArr = [];

    constructor(
        closeListener: EventListenerService,        
        private helpService: MyAccountService,
        private commonService:CommonService,
        private fb:FormBuilder,
        private ngProgress: NgProgressService,
    ) {
        super(closeListener);
    }

    ngOnInit():void {

        this.helpForm = this.fb.group({
            helptext:['', Validators.required],
        });
    }

    //Called when a end-user upload a image
    onSelectFile(event) : void {
        this.fileList = event.target.files;
        // Multiple Image uploading
        // for (var i = 0; i < this.fileList.length; i++) {
        //     console.log(this.fileList[i]);
        //     this.fileListArr.push(this.fileList[i]);
        // }

        // if(this.fileListArr.length === this.fileList.length){
        //     for (var i = 0; i < this.fileListArr.length; i++) {
        //         this.formData.append(this.fileListArr[i].name, this.fileListArr[i]);
        //     }
        // }

        // Single Image uploading
        if(this.fileList.length > 0){
            console.log("user uplaod a image");
            this.imageFile = event.target.files[0];
            this.formData.append(this.imageFile.name, this.imageFile);
            for (var i = 0; i <= this.fileList.length - 1; i++) {
                this.fileListArr.push(this.fileList[i]);
            }
          
        }
    }
    onSubmit(): void {
        if(this.helpForm.valid){
            this.hasEmptyQuestions = false;
            this.completeSubmission = true;
            this.ngProgress.start();
            this.sendComments.Comments = this.helpForm.get('helptext').value.toString();
            this.passQuestionSubscription$ = this.helpService.passFeedbackInfo(this.sendComments.Comments, this.formData).subscribe(
                (data: ApiResponse) => {
                    this.response = data;
                    this.disableButton = true;
                    this.errorMsg = data.responseMessage;
                    this.commonService.showResult("#send-help-button", this.errorMsg, "left", 3000);
                },
                (error: any) =>{ console.log(error);},
                () =>{
                    //Complete Uploading files and send Email
                    this.ngProgress.done();
                    //Destroy component itself
                    setTimeout(()=>{this.close();}, 4000);
                    // if(this.response.status === true){
                    // }
            });
        }else{
            this.hasEmptyQuestions = false;
            this.completeSubmission = false;
        }
    }

    // ngOnDestroy(): void {
    //     console.log('destroy');
    //     if(this.passQuestionSubscription$){
    //         this.passQuestionSubscription$.unsubscribe();
    //     }
    // }
}
